import type { SavedEmailTemplate } from "@redotech/redo-model/saved-email-template";
import { savedEmailTemplateSchema } from "@redotech/redo-model/saved-email-template";
import { SortDirection } from "@redotech/redo-model/tables/table";
import { zExt } from "@redotech/rpc/ext";
import { z } from "zod";

export const getSavedEmailTemplates = {
  input: z.object({
    sortDirection: z.nativeEnum(SortDirection).optional(),
    limit: z.number().positive().optional(),
    lastId: zExt.objectId().optional(),
  }),
  output: z.object({
    data: z.array(savedEmailTemplateSchema as z.ZodType<SavedEmailTemplate>),
    paginationKey: z.string().optional(),
  }),
};
